import './styles.scss';

export const MultiCheckboxGroup = ({ options, selectedValues, onChange, style = {} }) => {
  const toggleValue = (val) => {
    const updated = selectedValues.includes(val)
      ? selectedValues.filter((v) => v !== val)
      : [...selectedValues, val];
    onChange(updated);
  };

  return (
    <div className="multi-checkbox-group" style={style}>
      {options.map(({ label, value }) => (
        <button
          key={value}
          type="button"
          className={`toggle-button ${selectedValues.includes(value) ? 'selected' : ''}`}
          onClick={() => toggleValue(value)}
        >
          <input
            type="checkbox"
            className="toggle-checkbox"
            checked={selectedValues.includes(value)}
            readOnly
          />
          <span className="toggle-label">{label}</span>
        </button>
      ))}
    </div>
  );
};
